import { render, staticRenderFns } from "./EmployeeDetailsForm.vue?vue&type=template&id=2bf4f399&scoped=true&"
import script from "./EmployeeDetailsForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4f399",
  null
  
)

export default component.exports